import {
  GraphQLObjectType,
  GraphQLString,
  GraphQLList,
  GraphQLBoolean,
  GraphQLFloat
} from 'graphql';

import BlockTypeEnumType from './enums/blockTypeEnum.gql';
import BlockVariantEnumType from './enums/blockVariantEnum.gql';
import BlockFamilyEnumType from './enums/blockFamilyEnum.gql';
import BlockEmbedEnumType from './enums/blockEmbedEnum.gql';

const BlockSettingType = new GraphQLObjectType({
  name: 'BlockSettingType',
  fields: () => ({
    imagePosition: {
      type: GraphQLString
    },
    paddingBottom: {
      type: GraphQLFloat
    },
    paddingTop: {
      type: GraphQLFloat
    },
    backgroundColor: {
      type: GraphQLString
    },
    opacity: {
      type: GraphQLFloat
    },
    opacityColor: {
      type: GraphQLString
    },
    zoomOnClick: {
      type: GraphQLBoolean
    }
  })
});

const BlockAnswerType = new GraphQLObjectType({
  name: 'BlockAnswerType',
  fields: () => ({
    text: {
      type: GraphQLString
    },
    correct: {
      type: GraphQLBoolean
    }
  })
});

const MediaAttachmentType = new GraphQLObjectType({
  name: 'MediaAttachmentType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    fileName: {
      type: GraphQLString
    },
    fileSize: {
      type: GraphQLFloat
    }
  })
});

const EmbedType = new GraphQLObjectType({
  name: 'EmbedType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    type: {
      type: BlockEmbedEnumType
    }
  })
});

const MediaImageType = new GraphQLObjectType({
  name: 'MediaImageType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    thumbnail: {
      type: GraphQLString
    },
    isProcessing: {
      type: GraphQLBoolean
    },
    size: {
      type: GraphQLFloat
    },
    placeHolder: {
      type: GraphQLString
    }
  })
});

const MediaAudioType = new GraphQLObjectType({
  name: 'MediaAudioType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    thumbnail: {
      type: GraphQLString
    },
    isProcessing: {
      type: GraphQLBoolean
    }
  })
});

const MediaVideoType = new GraphQLObjectType({
  name: 'MediaVideoType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    hlsUrl: {
      type: GraphQLString
    },
    thumbnail: {
      type: GraphQLString
    },
    isProcessing: {
      type: GraphQLBoolean
    },
    meta: {
      type: GraphQLString
    }
  })
});

const BlockMediaImageType = new GraphQLObjectType({
  name: 'BlockMediaImageType',
  fields: () => ({
    src: {
      type: GraphQLString
    },
    thumbnail: {
      type: GraphQLString
    },
    size: {
      type: GraphQLFloat
    },
    key: {
      type: GraphQLString
    },
    originalUrl: {
      type: GraphQLString
    }
  })
});

const BlockMediaSubMediaType = new GraphQLObjectType({
  name: 'BlockMediaSubMediaType',
  fields: () => ({
    image: {
      type: BlockMediaImageType
    }
  })
});

const BlockMediaType = new GraphQLObjectType({
  name: 'BlockMediaType',
  fields: () => ({
    video: {
      type: MediaVideoType
    },
    audio: {
      type: MediaAudioType
    },
    image: {
      type: MediaImageType
    },
    embed: {
      type: EmbedType
    },
    attachment: {
      type: MediaAttachmentType
    },
    media: {
      type: BlockMediaSubMediaType
    }
  })
});

const FlashcardInfoType = new GraphQLObjectType({
  name: 'FlashcardInfoType',
  fields: () => ({
    media: {
      type: BlockMediaType
    },
    description: {
      type: GraphQLString
    },
    type: {
      type: GraphQLString
    }
  })
});

const BlockItemInfoType = new GraphQLObjectType({
  name: 'BlockItemInfoType',
  fields: () => ({
    media: {
      type: BlockMediaType
    },
    name: {
      type: GraphQLString
    },
    avatar: {
      type: BlockMediaType
    },
    background: {
      type: BlockMediaType
    },
    caption: {
      type: GraphQLString
    },
    questionText: {
      type: GraphQLString
    },
    answers: {
      type: new GraphQLList(BlockAnswerType),
      resolve: item => item.answers.slice()
    },
    paragraph: {
      type: GraphQLString
    },
    heading: {
      type: GraphQLString
    },
    subheading: {
      type: GraphQLString
    },
    html: {
      type: GraphQLString
    },
    front: {
      type: FlashcardInfoType
    },
    back: {
      type: FlashcardInfoType
    }
  })
});

const blockType = new GraphQLObjectType({
  name: 'Block',
  fields: () => ({
    id: {
      type: GraphQLString
    },
    pid: {
      type: GraphQLString,
      resolve: item => item._id
    },
    type: {
      type: BlockTypeEnumType
    },
    variant: {
      type: BlockVariantEnumType
    },
    family: {
      type: BlockFamilyEnumType
    },
    items: {
      type: new GraphQLList(BlockItemInfoType),
      resolve: item => item.items.slice()
    },
    settings: {
      type: BlockSettingType
    }
  })
});

window[blockType.name + 'GQLType'] = blockType;

export default blockType;
